export default __webpack_public_path__ + "static/media/icon-logo.eef0ef8b.png";